import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close, Description } from "@mui/icons-material";
import DocumentPreview from "components/_refactor/document-preview";

export default function DialogPreviewManual({ open, onClose, manual }) {
  const handleDownload = () => {
    if (manual?.UrlArquivo) {
      window.open(manual.UrlArquivo, "_blank");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Description style={{ marginRight: "12px" }} />
            {manual?.NomeManual || "Visualizar Manual"}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers>
        <DocumentPreview url={manual?.UrlArquivo} />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleDownload}
          variant="contained"
          disabled={!manual?.UrlArquivo}
        >
          Download
        </Button>
        <Button onClick={onClose} variant="outlined">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
